class ProductBundle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  checkBundleVariant() {
    const bundleVariants = this.querySelectorAll('.js-product-bundle-variant:checked');
    const productDataVariants = document.querySelectorAll('input[product-data-variant]');

    if (!bundleVariants.length || !productDataVariants.length) return;

    const checkedValues = Array.from(bundleVariants).map((input) => input.value);

    productDataVariants.forEach((productInput) => {
      const shouldBeChecked = checkedValues.includes(productInput.value);

      if (productInput.checked !== shouldBeChecked) {
        productInput.checked = shouldBeChecked;
        productInput.dispatchEvent(new Event('change', { bubbles: true }));
        productInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  syncFromProductDataVariant() {
    const productDataVariants = document.querySelectorAll('input[product-data-variant]:checked');
    const bundleVariants = this.querySelectorAll('.js-product-bundle-variant');

    if (!productDataVariants.length) return;

    const checkedValues = Array.from(productDataVariants).map((input) => input.value);

    bundleVariants.forEach((bundleInput) => {
      bundleInput.checked = checkedValues.includes(bundleInput.value);
    });
  }

  updateTitle() {
    const checkedVariant = this.querySelector('.js-product-bundle-variant:checked');
    const titleElement = this.querySelector('.js-bundle-variant-title');

    if (titleElement) {
      titleElement.textContent = checkedVariant ? checkedVariant.value : '';
    }
  }

  updateBundleImage() {
    const checkedVariant = this.querySelector('.js-product-bundle-variant:checked');
    if (!checkedVariant) return;
    const bundleItems = document.querySelectorAll('.product-bundle__item');

    bundleItems.forEach((item) => {
      const swatchInputs = item.querySelectorAll('.js-swatch-bundle');
      const matchingSwatch = Array.from(swatchInputs).find((input) => input.value === checkedVariant.value);

      if (matchingSwatch && matchingSwatch.dataset.image) {
        const bundleImage = item.querySelector('.product-bundle__image');
        if (bundleImage) {
          bundleImage.src = matchingSwatch.dataset.image;
        }
      }
    });
  }

  updateBundlePrice() {
    const checkedVariant = this.querySelector('.js-product-bundle-variant:checked');
    if (!checkedVariant) return;
    const bundleItems = document.querySelectorAll('.product-bundle__item');

    bundleItems.forEach((item) => {
      const swatchInputs = item.querySelectorAll('.js-swatch-bundle');
      const matchingSwatch = Array.from(swatchInputs).find((input) => input.value === checkedVariant.value);

      if (matchingSwatch) {
        const priceOriginal = item.querySelector('.product-bundle__price--original');
        const priceDiscount = item.querySelector('.product-bundle__price--discount');
        const savingsPrice = item.querySelector('.product-bundle__savings--price');

        if (priceOriginal && matchingSwatch.dataset.price) {
          priceOriginal.textContent = matchingSwatch.dataset.price;
        }
        if (priceDiscount && matchingSwatch.dataset.priceCompare) {
          priceDiscount.textContent = matchingSwatch.dataset.priceCompare;
        }
        if (savingsPrice && matchingSwatch.dataset.saving) {
          savingsPrice.textContent = matchingSwatch.dataset.saving;
        }
      }
    });
  }

  init() {
    this.syncFromProductDataVariant();
    this.checkBundleVariant();
    this.updateTitle();
    this.updateBundleImage();
    this.updateBundlePrice();

    this.addEventListener('change', (e) => {
      if (e.target.matches('.js-product-bundle-variant')) {
        this.checkBundleVariant();
        this.updateTitle();
        this.updateBundleImage();
        this.updateBundlePrice();
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('.sticky-atc-bar__variant-select')) {
        const selectedOption = e.target.selectedOptions[0];
        if (selectedOption && selectedOption.dataset.value) {
          const targetValue = selectedOption.dataset.value;
          const matchingVariant = this.querySelector(`.js-product-bundle-variant[value="${targetValue}"]`);
          if (matchingVariant) {
            matchingVariant.checked = true;
            this.checkBundleVariant();
            this.updateTitle();
            this.updateBundleImage();
            this.updateBundlePrice();
          }
        }
      }
    });
  }
}

customElements.define('product-bundle', ProductBundle);
